export default __webpack_public_path__ + "static/media/p1.0a5f1d0a.jpg";